// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"427":"f354facf","840":"2be70bd6"}[chunkId] + ".js";
};